// extracted by mini-css-extract-plugin
module.exports = {"other-reason":"_1I5ncBn7ucKJ92ThFsyz7z"};